/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Floor_AreaInputs */

const cs_form_floor_area = /** @type {(inputs: Form_Floor_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podlahová plocha (m²)`)
};

const en_form_floor_area = /** @type {(inputs: Form_Floor_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor area (m²)`)
};

/**
* | output |
* | --- |
* | "Floor area (m²)" |
*
* @param {Form_Floor_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_floor_area = /** @type {((inputs?: Form_Floor_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Floor_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_floor_area(inputs)
	return cs_form_floor_area(inputs)
});